module.exports = __webpack_public_path__ + "static/img/The Hanged Man.2c608f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The Hanged Man.jpg
// module id = 1313
// module chunks = 0